<div class="cm-placeholder" [class.cm-placeholder--loading]="$loading()" [class.cm-placeholder--dark]="$dark()" [class]="'cm-placeholder--' + $format()"></div>
